module.exports = __webpack_public_path__ + "img/top-right.d0402bac.png";